import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ClientDashboad, Layout } from '../../pages/client';

const Client = () => {
    return (
        <div>
          <Routes>
                <Route element={<Layout />} >
                    <Route index element={<ClientDashboad />} />
                    <Route path='/dashboad' element={<ClientDashboad />} />
                </Route>
            </Routes>  
        </div>
    );
};

export default Client;